"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ObjectIdentifierList_1 = require("./_ObjectIdentifierList");
exports._Delete = {
    type: "structure",
    required: ["Objects"],
    members: {
        Objects: {
            shape: _ObjectIdentifierList_1._ObjectIdentifierList,
            locationName: "Object"
        },
        Quiet: {
            shape: {
                type: "boolean"
            }
        }
    }
};
//# sourceMappingURL=_Delete.js.map